import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CustomersTable from './customers-table.jsx';

if (document.getElementById(
  'react-component-g4-logistics-portal-all-customers')) {
  ReactDOM.render(
    <CustomersTable
      message_if_none = 'No Customers found. Add one to see it here.'
      disableEchoChannelCustomerJobsTableChanged = {true}
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-all-customers'
    )
  );
}